

import { VideoSettingsData, IFieldDisplayData } from "widgets/commonDataObjects/interfaces"
import { MultiImagesScroller, getItemMargin } from "widgets/commonComponents/base/multiImagesFrontScroller";
import { SiteItemData } from "widgets/interfaces"
import { googleScript } from "../../../../widgetsUtils"
import { MultiImagesItemFront } from "./multiImagesItemFront";

interface MultiImagesFrontProps {
    itemList: SiteItemData[]
    width: number
    fieldsDisplaySettings: IFieldDisplayData
    videoSettings: VideoSettingsData
    imageWidth: number
    imageHeight: number
    onRowDisplay: boolean
    titleColor: string
    isYplusComp?: boolean
    isImageOnly?: boolean
    ads_infrastructure_type?: string
}

export class MultiImagesRadionasFront extends React.Component<MultiImagesFrontProps>{
    public static siteScriptName = "MultiImagesRadionasFront";
    public render() {
        const { imageWidth, itemList, imageHeight, videoSettings, fieldsDisplaySettings, width, onRowDisplay, titleColor, isYplusComp, isImageOnly, ads_infrastructure_type } = this.props
        const itemStyle = { marginLeft: getItemMargin(width, imageWidth)};
        if (onRowDisplay) return (
            <MultiImagesScroller imageWidth={imageWidth} width={width} itemLength={itemList.length}>
                {itemList.map((slot, index) => {
                    if (slot.isDFP) return <div id={slot.dfpId} key={index} className={`slotView dfpId ${slot.isCommertial ?  "commertialStyle" : ""}`} style={itemStyle}>
                         {ads_infrastructure_type && ads_infrastructure_type === "new" && <script type="text/javascript" dangerouslySetInnerHTML={{ __html: googleScript(slot.dfpId) }}></script>}
                    </div>
                    else return (
                        <MultiImagesItemFront
                            imageWidth={imageWidth}
                            key={index}
                            imageHeight={imageHeight}
                            videoSettings={videoSettings}
                            fieldsDisplaySettings={fieldsDisplaySettings}
                            item={slot}
                            titleColor={titleColor}
                            margin={getItemMargin(width, imageWidth)}
                            onRowDisplay={onRowDisplay}
                            isYplusComp={isYplusComp}
                            isSmallItem={true}
                            isImageOnly = {isImageOnly}
                        />
                    )
                }
                )}
            </MultiImagesScroller >)
        else return (
            <div className="slotsContent">{itemList.map((slot, index) => {
                if (slot.isDFP) return <div id={slot.dfpId} key={index} className={`slotView dfpId ${slot.isCommertial ? "commertialStyle" : ""}`} style={{ margin: "0 10px 24px" }} >
                    {ads_infrastructure_type && ads_infrastructure_type === "new" && <script type="text/javascript" dangerouslySetInnerHTML={{ __html: googleScript(slot.dfpId) }}></script>}
                </div>
                else return (
                    <MultiImagesItemFront
                        imageWidth={imageWidth}
                        key={index}
                        imageHeight={imageHeight}
                        videoSettings={videoSettings}
                        fieldsDisplaySettings={fieldsDisplaySettings}
                        item={slot}
                        margin={getItemMargin(width, imageWidth)}
                        onRowDisplay={onRowDisplay}
                        titleColor={titleColor}
                        isYplusComp={isYplusComp}
                        isSmallItem={true}
                        isImageOnly = {isImageOnly}
                    />
                )
            }
            )}  </div>
        )
    }
}